// Safe Sentry payload for the AI-generated chip. Callers pass dispatch and
// LaunchError so this module stays importable from node:test.

const SAFE_SECTION = /^[A-Za-z][A-Za-z0-9_]{0,40}$/;
const FUNCTION_NAMES = new Set([
  "getIsAIGeneratedSection",
  "stampAIGeneratedSections",
  "mergeAIGeneratedSectionFingerprint",
]);

export const buildAIGeneratedSentryContext = (context = {}) => {
  const safe = {};
  if (SAFE_SECTION.test(context?.section || "")) {
    safe.section = context.section;
  }
  if (
    typeof context?.sectionCount === "number" &&
    Number.isFinite(context.sectionCount)
  ) {
    safe.sectionCount = context.sectionCount;
  }
  return safe;
};

export const buildAIGeneratedChipReport = ({ functionName, context } = {}) => {
  const safeFunctionName = FUNCTION_NAMES.has(functionName)
    ? functionName
    : "getIsAIGeneratedSection";
  const error = new Error(`${safeFunctionName} failed`);
  error.code = "aiGeneratedChipFailed";
  return {
    error,
    showAlert: false,
    sentryMeta: {
      functionName: safeFunctionName,
      context: buildAIGeneratedSentryContext(context),
      tags: { action: "aiGeneratedChip" },
      level: "warning",
    },
  };
};

export const dispatchAIGeneratedChipFailure = ({
  dispatch,
  launchError,
  functionName,
  context,
}) => {
  const report = buildAIGeneratedChipReport({ functionName, context });
  if (typeof dispatch !== "function" || typeof launchError !== "function") {
    return report;
  }
  dispatch(launchError(report.error, report.showAlert, [], report.sentryMeta));
  return report;
};
